import { render, staticRenderFns } from "./announceTemplate.vue?vue&type=template&id=0191b0d8&lang=true&"
import script from "./announceTemplate.vue?vue&type=script&lang=js&"
export * from "./announceTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports